import React from 'react'
import { useFormikContext } from 'formik'
import { useTranslate } from 'react-admin'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import CancelIcon from '@material-ui/icons/Cancel'
import AddIcon from '@material-ui/icons/Add'
import MyTextField from '../../form/fields/MyTextField'
import GAME_EVENT_FORM_BROADCAST_FIELDS from '../../../utils/constants/gameEventFormBroadcastFields'
import { isFormFieldDisabled } from '../../../utils/helpers/isFieldDisabled'
import ConditionalRender from '../../ConditionalRender/ConditionalRender'
import streamFieldsStyles from './streamFields.styles'

const ExtraStreamField = ({ state, variant }) => {
  const { values, setFieldValue } = useFormikContext()
  const translate = useTranslate()
  const useStyles = makeStyles(streamFieldsStyles)
  const classes = useStyles()

  const isAdditionalStreamDestinationAdded =
    values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_ADDITIONAL_STREAM_DESTINATION_ADDED]

  const isAddDisabled = isFormFieldDisabled(
    state,
    GAME_EVENT_FORM_BROADCAST_FIELDS.IS_ADDITIONAL_STREAM_DESTINATION_ADDED,
  )

  const toggleExtraStreamKeyValue = () =>
    setFieldValue(
      GAME_EVENT_FORM_BROADCAST_FIELDS.IS_ADDITIONAL_STREAM_DESTINATION_ADDED,
      isAdditionalStreamDestinationAdded !== true,
    )

  // Compact coral text link used in the DESTINATION footer to reveal the extra stream key input.
  if (variant === 'addLink') {
    return (
      <ConditionalRender renderValue={!isAdditionalStreamDestinationAdded}>
        <span
          role='button'
          tabIndex={isAddDisabled ? -1 : 0}
          onClick={() => !isAddDisabled && toggleExtraStreamKeyValue()}
          onKeyDown={(event) => {
            if ((event.key === 'Enter' || event.key === ' ') && !isAddDisabled) {
              event.preventDefault()
              toggleExtraStreamKeyValue()
            }
          }}
          className={classes.addStreamKeyLink}
          style={{
            opacity: isAddDisabled ? 0.5 : 1,
            pointerEvents: isAddDisabled ? 'none' : 'auto',
          }}
        >
          <AddIcon className={classes.addStreamKeyIcon} />
          {translate('ra.gameDrawer.addStreamKey')}
        </span>
      </ConditionalRender>
    )
  }

  return (
    <ConditionalRender renderValue={isAdditionalStreamDestinationAdded}>
      <div className='div-flex'>
        <MyTextField
          name={GAME_EVENT_FORM_BROADCAST_FIELDS.STREAM_DESTINATION_2}
          label={translate('ra.formFields.streamKeyURI2')}
          fullWidth
          disabled={isFormFieldDisabled(state, GAME_EVENT_FORM_BROADCAST_FIELDS.STREAM_DESTINATION_2)}
        />
        <CancelIcon className={classes.cancelIcon} onClick={toggleExtraStreamKeyValue} />
      </div>
    </ConditionalRender>
  )
}

ExtraStreamField.defaultProps = {
  variant: 'field',
}

ExtraStreamField.propTypes = {
  state: PropTypes.string,
  variant: PropTypes.oneOf(['field', 'addLink']),
}

export default ExtraStreamField
